console.log(window.RFQ_TRANSLATIONS);

function saveForm() {
    const container = document.querySelector('.rfq-accordion'); 
    const formData = {
        name: container.querySelector('[name="rfq_name"]')?.value || "",
        last_name: container.querySelector('[name="rfq_last_name"]')?.value || "",
        email: container.querySelector('[name="rfq_email"]')?.value || "",
        phone: container.querySelector('[name="rfq_phone"]')?.value || "",
        message: container.querySelector('[name="rfq_message"]')?.value || "",
        country: container.querySelector('[name="rfq_country"]')?.value || ""
    };
    localStorage.setItem("rfq_form", JSON.stringify(formData));
}

$('#variant-selects').on('change', 'input', function () {
  const value = $('#variant-selects').find('input:checked').val();
  console.log(value);
});


document.addEventListener("DOMContentLoaded", () => {
    const container = document.querySelector('.rfq-accordion');
    const rfqState = {
        products: loadSavedProducts() 
    };

    function loadSavedProducts() {
        try {
            const saved = localStorage.getItem("rfq_products");
            return saved ? JSON.parse(saved) : [];
        } catch (e) {
            console.error("Error loading saved RFQ products:", e);
            return [];
        }
    }

    function saveProducts() {
        localStorage.setItem("rfq_products", JSON.stringify(rfqState.products));
    }

    const overlay = document.getElementById("rfq_popup") || document.getElementById("rq_popup");
    const closeBtn = document.getElementById("rfq_close_btn") || document.getElementById("rq_popup_close");
    const productsContainer = document.getElementById("rfq_products_container");
    const nextBtn1 = document.getElementById("rfq_next_1");
    const continueShoppingBtn = document.getElementById("rfq_continue_shopping");
    const back2 = document.getElementById("rfq_back_2");
    const next2 = document.getElementById("rfq_next_2");
    const back3 = document.getElementById("rfq_back_3");
    const submitBtn = document.getElementById("rfq_submit_btn");
    const reviewSection = document.getElementById("rfq_review_section");
    const step1El = document.querySelector(".rfq_step_1");
    const step2El = document.querySelector(".rfq_step_2");
    const step3El = document.querySelector(".rfq_step_3");
    const stepHeaders = document.querySelectorAll(".rfq-step");
    const nameInput = container.querySelector('[name="rfq_name"]');
    const lastnameInput = container.querySelector('[name="rfq_last_name"]');
    const emailInput = container.querySelector('[name="rfq_email"]');
    const phoneInput = container.querySelector('[name="rfq_phone"]');
    const messageInput = container.querySelector('[name="rfq_message"]');
    const selectedCountry = container.querySelector('[name="rfq_country"]');

    // -------------------------------
    // Load saved form values
    // -------------------------------


    function formatMoneyFromRaw(priceRaw, currency) {
        if (!priceRaw) return "";
        const cents = parseInt(priceRaw, 10);
        const dollars = (cents / 100).toFixed(2);
        return `${currency} ${dollars}`;
    }

    function openPopup() {
        resetRfqPopup();
        if (!overlay) return;
        overlay.style.display = "flex";
        goToStep(1);
        renderProducts();
    }

    function closePopup() {
        if (!overlay) return;
        overlay.style.display = "none";
    }

    if (closeBtn) closeBtn.addEventListener("click", closePopup);
    if (overlay) overlay.addEventListener("click", function(e) {
        if (e.target === overlay) closePopup();
    });

    // -------------------------------
    // Add product to state
    // -------------------------------
    function addProduct(product) {
        resetRfqPopup();
        if(window.RFQ_TRANSLATIONS.isCustomerLoggedIn == false){
            console.log('customer is not logged in yet........');
        } else {
            console.log('customer logged in',product);
        }

        const exists = rfqState.products.find(p => p.variantid === product.variantid);
        let originalStoreProdPrice = product.price;

        if (exists) {
                exists.qty = Math.min(999, exists.qty + (product.qty || 1));
            } else {
                rfqState.products.push({
                    id: product.id,
                    variantid: product.variantid,
                    handle: product.handle,
                    image: product.image,
                    priceRaw: product.priceRaw || null,
                    price: originalStoreProdPrice || "",
                    qty: product.qty || 1,
                    title: product.title,
                    options:product.options,
                    variants:product.variants
                });
        }
        
        saveProducts();
        renderProducts();
        openPopup();
    }

    function removeProduct(vId) {
        rfqState.products = rfqState.products.filter(p => p.variantid !== vId);
        saveProducts(); // Save to localStorage on remove
        updateRFQCount();
        renderProducts();
    }

    renderProducts(); // Render saved products on page load

    function renderProducts() {
        console.log('renderProducts.........');
        if (!productsContainer) return;
        productsContainer.innerHTML = "";

        if (rfqState.products.length === 0) {
            productsContainer.innerHTML = `<tr><td colspan="3" class="no-item-added" style="padding:24px;text-align:center;color:#6b7280;">`+window.RFQ_TRANSLATIONS.no_product_found_msg+`</td></tr>`;
            document.querySelector('.rfq-buttons #rfq_next_1').disabled = true;
            return;
        }

        const productsToFetch = rfqState.products.map(p => ({
            handle: p.handle,
            variantId: p.variantid
        }));
         
        const fetchVariantData = ({ handle, variantId }) => {
            const url =
                Shopify.locale === 'ar'
                ? `/ar/products/${handle}.js`
                : `/products/${handle}.js`;

            return fetch(url)
                .then(res => {
                    if (!res.ok) {
                        return { __invalid: true };
                    }
                    return res.json();
                })
                .then(prod => {
                    if (prod.__invalid) {
                       return { invalid: true };
                    }
                    const prodOptions = [];
                    const selectedVariants = [];
                    const variant = prod.variants.find(v => v.id == variantId);
                    if (Array.isArray(prod.options) && prod.options.length > 0) {
                        prod.options.forEach((option, i) => {
                            console.log(option);
                            prodOptions.push(option.name);
                            selectedVariants.push(variant['option' + (i + 1)]);
                        });
                    } else {
                        console.log('Options not available...');
                    }

                    let finalPrice = variant.price / 100;

                    if (window.customerTypeDiscount && window.customerTypeDiscount > 0) {
                        finalPrice = finalPrice - (finalPrice * (window.customerTypeDiscount / 100));
                    }
                    return {
                        invalid: false,
                        price: finalPrice.toFixed(2),
                        title: prod.title,
                        options: prodOptions,
                        variants: selectedVariants
                    };
                });
        };

        Promise.all(
            productsToFetch.map((p, index) =>
                fetchVariantData(p).then(data => {
                    rfqState.products[index].invalid = data.invalid === true;
                    if (!data.invalid) {
                        rfqState.products[index].price = data.price;
                        rfqState.products[index].title = data.title;
                        rfqState.products[index].options = data.options;
                        rfqState.products[index].variants = data.variants;
                    }
                    return data;
                })
            )
        ).then(() => {
            console.log("renderProducts..........rfqState updated:", rfqState.products);
        });
        

        rfqState.products.forEach((p) => {
            let className = '';
            const tr = document.createElement("tr");
            tr.dataset.productId = p.id;
            if (p.invalid) {
                className = 'invalid_product';
            }
            const errorHtml = p.invalid
                            ? `<div class="rfq-error">
                                ${window.RFQ_TRANSLATIONS?.product_unavailable_msg}
                            </div>`
                            : '';
            const title = p.title;
            let optionsHtml = '';
            let variants = p.variants;
            if (typeof variants === 'string') {
                try {
                    variants = JSON.parse(variants);
                } catch(e) {
                    variants = [variants];
                }
            }
            if (Array.isArray(p.options) && Array.isArray(variants)) {
                p.options.forEach((opt, i) => {
                    const val = variants[i] || '';
                    console.log('val...........',val);
                    if (val.toLowerCase() === 'default title' || val.trim().toLowerCase() === '') return; // skip if value is "default title"
                    optionsHtml += `<div>${escapeHtml(opt)}: ${val}</div>`;
                });
            }
                
            tr.innerHTML = `
                <td class="rfq-prod-info">
                    <div class="rfq-product-cell rfq-dim">
                        <img src="${p.image || ''}" alt="${escapeHtml(title)}" class="rfq-product-thumb ${className}"/>
                        <div>
                            <div style="font-weight:600;" class="prod-title ${className}">${escapeHtml(title)}</div>
                            <div class="prod-variants ${className}">
                                ${optionsHtml}
                            </div>
                            ${errorHtml}
                        </div>
                    </div>
                </td>
                <td>
                    <div class="rfq-qty">
                        <div class="rfq-dim ${className}">
                            <input type="number" min="1" value="${p.qty}" data-id="${p.variantid}" class="rfq-qty-input" />
                        </div>
                        <button class="rfq-remove-btn" data-id="${p.variantid}" title="Remove item"><svg
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                            focusable="false"
                            class="icon icon-remove"
                            viewBox="0 0 512 512">
                        <path d="M112 112l20 320c.95 18.49 14.4 32 32 32h184c17.67 0 30.87-13.51 32-32l20-320" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
                        <path stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32" d="M80 112h352"/>
                        <path d="M192 112V72h0a23.93 23.93 0 0124-24h80a23.93 23.93 0 0124 24h0v40M256 176v224M184 176l8 224M328 176l-8 224" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
                        </svg></button>
                    </div>
                </td>
                <td style="text-align:right;">
                    <div class="rfq-price ${className}">${theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, p.price)}</div>
                </td>\
            `;
            productsContainer.appendChild(tr);
        });
        document.querySelector('.rfq-buttons #rfq_next_1').disabled = false;

        productsContainer.querySelectorAll(".rfq-qty-input").forEach(input => {
            input.addEventListener("change", (e) => {
                const id = e.target.dataset.id;
                let val = parseInt(e.target.value, 10);
                if (!val || val < 1) val = 1;
                const item = rfqState.products.find(x => x.variantid === id);
                if (item) {
                    item.qty = val;
                    saveProducts(); //  Save on quantity change
                }
                renderTotals();
            });
        });

        productsContainer.querySelectorAll(".rfq-remove-btn").forEach(btn => {
            btn.addEventListener("click", (e) => {
                const id = e.currentTarget.dataset.id;
                removeProduct(id);
            });
        });
        renderTotals();
    }

    function renderTotals(){
        // Placeholder for future total calculation
    }

    function goToStep(stepIndex) {
        stepHeaders.forEach(sh => {
            const s = parseInt(sh.dataset.step, 10);
            sh.classList.toggle("active", s === stepIndex);
        });
        const allSteps = document.querySelectorAll(".rfq_step_1, .rfq_step_2, .rfq_step_3");
        allSteps.forEach(el => el.style.display = "none");

        // Show only the current step
        const currentStep = document.querySelectorAll(`.rfq_step_${stepIndex}`);
        currentStep.forEach(el => el.style.display = "");
    }

    if (nextBtn1) nextBtn1.addEventListener("click", () => {
        if (rfqState.products.length === 0) {
            alert("Please add at least one product to request a quote.");
            return;
        }
        const invalidProduct = rfqState.products.find(p => p.invalid === true);
            if (invalidProduct) {
            const invalidRow = productsContainer.querySelector(
                `tr[data-product-id="${invalidProduct.id}"]`
            );
            if (invalidRow) {
                invalidRow.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                invalidRow.classList.add("rfq-highlight-error");
                setTimeout(() => {
                    invalidRow.classList.remove("rfq-highlight-error");
                }, 1500);
            }
            return;
        }
        animateStepHeader(2);
        goToStep(2);
    });

    if (continueShoppingBtn) continueShoppingBtn.addEventListener("click", closePopup);
    if (back2) back2.addEventListener("click", () => {
        animateStepHeader(1);
        goToStep(1);
    });

    // -------------------------------
    // Save form data on input/change
    // -------------------------------
    const forms = document.querySelectorAll('.rfq-accordion');

    forms.forEach(container => {
        const nameInput = container.querySelector('[name="rfq_name"]');
        const lastNameInput = container.querySelector('[name="rfq_last_name"]');
        const emailInput = container.querySelector('[name="rfq_email"]');
        const phoneInput = container.querySelector('[name="rfq_phone"]');
        const messageInput = container.querySelector('[name="rfq_message"]');
        const selectedCountry = container.querySelector('[name="rfq_country"]');

        // Save form on input/change
        [nameInput, lastNameInput, emailInput, phoneInput, messageInput, selectedCountry].forEach(el => {
            if (!el) return;
            el.addEventListener("input", saveForm);
            el.addEventListener("change", saveForm);
        });
    });
    if (next2) next2.addEventListener("click", () => {
        console.log("here i ammmmmmmmmmmm");
        let valid = true;
        document.querySelectorAll(".rfq-error").forEach(e => e.textContent = "");
        const containers = document.querySelectorAll('.rfq-accordion');
        containers.forEach(container => {
            const firstName = container.querySelector('[name="rfq_name"]');
            const lastName = container.querySelector('[name="rfq_last_name"]');
            const email = container.querySelector('[name="rfq_email"]');
            const phone = container.querySelector('[name="rfq_phone"]');
          
            if (!firstName || !lastName || !email || !phone) return;

            if (!firstName.value.trim()) {
                firstName.closest(".rfq-field").querySelector(".rfq-error").textContent = window.RFQ_TRANSLATIONS.first_name_required;
                valid = false;
            }

            if (!lastName.value.trim()) {
                lastName.closest(".rfq-field").querySelector(".rfq-error").textContent = window.RFQ_TRANSLATIONS.last_name_required;
                valid = false;
            }

            const emailVal = email.value.trim();
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailVal) {
                email.closest(".rfq-field").querySelector(".rfq-error").textContent = window.RFQ_TRANSLATIONS.email_required;
                valid = false;
            } else if (!emailRegex.test(emailVal)) {
                email.closest(".rfq-field").querySelector(".rfq-error").textContent = window.RFQ_TRANSLATIONS.valid_email_required;
                valid = false;
            }

            const phoneVal = phone.value.trim();
            const iti = window.intlTelInputGlobals.getInstance(phone);
            const errorEl = phone.closest(".rfq-field").querySelector(".rfq-error");

            if (!phoneVal) {
                errorEl.textContent = window.RFQ_TRANSLATIONS.phone_required;
                valid = false;
            } else if (!iti || !iti.isValidNumber()) {
                errorEl.textContent = window.RFQ_TRANSLATIONS.valid_required;
                valid = false;
            } else {
                errorEl.textContent = "";
                // Format number in E.164 before submitting
                phone.value = iti.getNumber(intlTelInputUtils.numberFormat.NATIONAL);
            }
        });

        if (!valid) return;

        saveForm(); // 🌟 Save form before going to review

        populateReview();
        animateStepHeader(3);
        goToStep(3);
    });

    if (back3) back3.addEventListener("click", () => {
        animateStepHeader(2);
        goToStep(2);
    });

    function populateReview() {
        if (!reviewSection) return;
        reviewSection.innerHTML = "";
        const productList = document.createElement("div");
        productList.className = "rfq-review-products";
        rfqState.products.forEach(p => {
            const row = document.createElement("div");
            row.className = "rfq-review-row";
            const title = p.title;
            const showVariants = p.variants.some(v => v && !v.includes('Default Title'));
            row.innerHTML = `
                <div class="rfq-review-left">
                    <img src="${p.image || ''}" alt="${escapeHtml(title)}" class="rfq-review-thumb"/>
                    <div>
                        <div class="rfq-review-title">${escapeHtml(title)}</div>
                        <div class="rfq-review-qty">${window.RFQ_TRANSLATIONS.quantity}: ${p.qty}</div>
                        ${
                            showVariants
                            ? p.options.map((opt, idx) => {
                                const variant = p.variants[idx] || '';
                                if (!variant.includes('Default Title')) {
                                    return `<div class="rfq-review-variants">${escapeHtml(opt)}: ${escapeHtml(variant)}</div>`;
                                } else {
                                    return '';
                                }
                            }).join('')
                            : ''
                        }
                    </div>
                </div>
                <div class="rfq-review-right">
                    ${theme.settings.moneyWithCurrencyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, p.price)}
                </div>
            `;
            productList.appendChild(row);

        });
        reviewSection.appendChild(productList);
        const contact = document.createElement("div");
        const direction = window.Shopify.locale == 'ar' ? 'rtl' : 'ltr';
        contact.className = "rfq-review-contact";

        let contactHTML = `
            <div class="rfq-section-header" style="margin-top:24px;">
                <h3>${window.RFQ_TRANSLATIONS.contact_header}</h3>
            </div>
        `;

        function addField(label, value) {
            console.log(label);
            if (!value) return ""; // skip empty
            return `<div dir="${direction}"><strong>${label}:</strong> ${escapeHtml(value)}</div>`;
        }

        contactHTML += addField(window.RFQ_TRANSLATIONS.name, nameInput.value+' '+lastnameInput.value);
        contactHTML += addField(window.RFQ_TRANSLATIONS.email, emailInput.value);
        contactHTML += addField(window.RFQ_TRANSLATIONS.phone, phoneInput.value);
        contactHTML += addField(window.RFQ_TRANSLATIONS.message, messageInput.value);
        const countrySelect = document.querySelector(".rfq_country");
        let countryText = countrySelect?.selectedOptions[0]?.text || "";
        contactHTML += addField(window.RFQ_TRANSLATIONS.country, countryText);
        contact.innerHTML = contactHTML;
        reviewSection.appendChild(contact);
    }

    function formatLineTotal(p) {
        const formatted = p.price || "";
        const currency = formatted.match(/^[^\d]+/)?.[0].trim() || "";
        return p.price || "";
    }

    if (submitBtn) submitBtn.addEventListener("click", async () => {
        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        submitBtn.classList.add("disabled");
        const payload = {
            contact: {
                first_name: nameInput.value,
                last_name: lastnameInput.value,
                email: emailInput.value,
                phone: phoneInput.value,
                message: messageInput.value,
                country: selectedCountry.value
            },
            customer: window.RFQ_CUSTOMER || null,
            currencyDetails: window.Shopify.currency.active,
            items: rfqState.products.map(p => ({ id: p.id, variantid: p.variantid, handle: p.handle, title: p.title, qty: p.qty, priceRaw: p.priceRaw, image: p.image })),
            created_at: new Date().toISOString(),
            myshopify_domain: window.Shopify.shop
        };
        try {
            const response = await fetch("https://storetest.ecs-eco.com/api/ecs-submit-request", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (!response.ok) {
                alert("Something went wrong while submitting!");
                return;
            }

            showThankYou();
            // Reset the popup state
            rfqState.products = [];
            saveProducts();
            localStorage.removeItem("rfq_form");
            submitBtn.disabled = false;
            submitBtn.classList.remove("disabled");
            updateRFQCount();
        } catch (error) {
            console.error("Error submitting RFQ:", error);
            alert("Error: Could not submit request.");
            submitBtn.disabled = false;
            submitBtn.classList.remove("disabled");
        }
    });

    function showThankYou() {
        const popup = document.getElementById("rfq_popup");
        const stepsIndicator = popup.querySelector(".rfq-steps");
        if (stepsIndicator) stepsIndicator.style.display = "none";
        const allContents = popup.querySelectorAll(".rfq-step-content, .rfq-step-container, .rfq-buttons");
        allContents.forEach(el => el.style.display = "none");
        const thankyou = popup.querySelector(".rfq-thankyou");
        thankyou.style.display = "flex";
        popup.style.display = "flex";
        const continueBtn = document.getElementById("rfq_continue_shopping_thankyou");
        if (continueBtn) {
            continueBtn.addEventListener("click", () => {
                closePopup();
            });
        }
    }

    function resetRfqPopup() {
        const popup = document.getElementById("rfq_popup");

        // Show step header
        const stepsHeader = popup.querySelector(".rfq-steps");
        if (stepsHeader) stepsHeader.style.display = "flex";

        // Hide thank you
        popup.querySelector(".rfq-thankyou").style.display = "none";

        // Hide all steps first
        popup
            .querySelectorAll(".rfq-step-content, .rfq-step-container, .rfq-buttons")
            .forEach(el => el.style.display = "none");

        // Show STEP 1 only
        popup.querySelector(".rfq_step_1").style.display = "block";
        popup.querySelector(".rfq-buttons.rfq_step_1").style.display = "flex";

        // Reset active step UI
        popup.querySelectorAll(".rfq-step").forEach(step => step.classList.remove("active"));
        popup.querySelector('.rfq-step[data-step="1"]').classList.add("active");
    }

    function showLogoutPopup(){
        const popup = document.querySelector('.logout-popup');
        popup.setAttribute('open', '');
        console.log("Customer is not logged in yet");
        e.preventDefault();
        return; // Stop further action
    }

    document.body.addEventListener("click", (e) => {
        const btn = e.target.closest && e.target.closest(".add-to-rfq");
        if (!btn) return;

        if (btn.classList.contains("logout")) {
            showLogoutPopup();
            return; // Stop further action
        }
        e.preventDefault();

        const productForm = btn.closest('product-form');
        var pdQty = 1;
        if (productForm) {
            const quantityInput = productForm.querySelector('.quantity__input');
            pdQty = quantityInput ? quantityInput.value : null;
        }
        const product = {
            id: btn.dataset.id ? String(btn.dataset.id) : (btn.dataset.handle || Math.random().toString(36).substr(2,9)),
            variantid: btn.dataset.variantid || "",
            handle: btn.dataset.handle || "",
            title: btn.dataset.title || btn.dataset.handle || "Product",
            image: btn.dataset.image || "",
            price: btn.dataset.price || "",
            priceRaw: btn.dataset.priceRaw || null,
            qty: parseInt(pdQty),
            options:btn.dataset.options ? JSON.parse(btn.dataset.options) : [],
            variants:btn.dataset.variants
        };
        addProduct(product);
        updateRFQCount();
    });

    function escapeHtml(unsafe) {
        if (!unsafe && unsafe !== 0) return "";
        return String(unsafe)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    }

    function animateStepHeader(nextStepNumber) {
        const steps = document.querySelectorAll(".rfq-step");

        steps.forEach(step => {
            const stepNum = step.getAttribute("data-step");

            if (stepNum == nextStepNumber) {
                step.classList.add("entering");
                setTimeout(() => {
                    step.classList.remove("entering");
                    step.classList.add("active", "entered");
                }, 20);
            } else {
                if (step.classList.contains("active")) {
                    step.classList.add("exiting");
                    setTimeout(() => {
                        step.classList.remove("active", "exiting", "entered");
                    }, 300);
                }
            }
        });
    }

    document.addEventListener('click', function (event) {
        const el = event.target.closest('.icon-rfq-header');
        if (!el) return;

        if (el.classList.contains('logout')) {
            console.log('logout');
            showLogoutPopup();
            return; // stop here
        }

        

        openPopup(); // only opens if NOT logout
    });


});
